import { useMemo } from "react";
import { theme } from "antd";
import { useTheme } from "../contexts/ThemeContext";

/**
 * Hook customizado para configuração do tema do Ant Design
 * Centraliza a lógica de configuração de cores e tokens
 */
export const useAntdThemeConfig = () => {
  const {
    theme: customTheme,
    isDarkMode,
    tenantTheme,
    whitelabelEnabled,
  } = useTheme();

  const themeConfig = useMemo(() => {
    // Verificar se deve usar cores customizadas do tenant
    const shouldUseCustomColors = whitelabelEnabled && tenantTheme?.colors?.primary;

    const finalPrimaryColor = shouldUseCustomColors
      ? tenantTheme.colors.primary
      : customTheme.primary;

    const finalTextColor = shouldUseCustomColors
      ? tenantTheme.colors.primary
      : customTheme.textSecondary;

    return {
      algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
      token: {
        colorPrimary: finalPrimaryColor,
        colorBgContainer: customTheme.backgroundSecondary,
        colorBgLayout: customTheme.background,
        colorText: finalTextColor,
        colorBorder: customTheme.border,
      },
    };
  }, [
    customTheme,
    isDarkMode,
    tenantTheme?.colors?.primary,
    whitelabelEnabled,
  ]);

  return themeConfig;
};